module.exports = __webpack_public_path__ + "img/link04.3583e666.gif";